import { User, Collection, Status } from ".";

export class CollectionUser{
    id? : number;
    parentCollection? : Collection;
    user?: User;
    status? : Status;
    createdAt?: Date = new Date();
    createdUser?: User;
    updatedAt?: Date;
    updatedUser?: User;
}
